import { useContext } from 'react';
import GlobalModalContext from './GlobalModalContext';

const useGlobalModal = () => useContext(GlobalModalContext);

export default useGlobalModal;
